import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';

import './Link.css';

class Link extends Component {
  render() {
    return (
      <Typography classes={this.props.classes} color={this.props.color || 'primary'} variant={this.props.variant} paragraph={false} style={{ display: this.props.block ? 'block' : 'inline' }}>
        <a href={`${process.env.PUBLIC_URL}${this.props.href}`}>{this.props.label || this.props.children}</a>
      </Typography>
    );
  }
}

export default Link;



// WEBPACK FOOTER //
// ./src/components/Link/Link.js